ObjectUtils.define('UIMembershipPlansController', UIController, {

  didControlChangeValue: function didControlChangeValue(container, target, data) {
    if (data.name === 'planPeriod') {
      var allContainers = DOM.findAllByClass(container, 'periodPriceContainer');
      ArrayUtils.each(allContainers, function(index, priceContainer) {
        var isSelected = DOM.hasClass(priceContainer, 'periodPriceContainer-'+data.value);
        DOM.addClassIf(priceContainer, 'selected', isSelected);
      });
    }

    return EventDelegater.FORWARD;
  },

});
